import { FormLabel, FormLabelProps } from "@mui/material";

interface Props extends FormLabelProps {}

export const Label = (props: Props) => {
  return <FormLabel {...props} />;
};
